import UserOrders from './UserOrders';
import { withUserOrders, buildUserOrders } from '../../data-providers/orders';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import withCountry from '../../hocs/withCountry';
import { withRouter } from 'react-router';
import { fetchUserOrders } from '../../../facades/eagle/user';
import { replaceRichText } from 'src/common/utils/text-replace';
import when from 'recompose/branch';
import { localiseUrl } from 'src/common/utils/format-localised-url';
import logger from 'src/logger';

const enhanceSingleOrder = compose(
  withRouter,
  mapProps(({ match, ...props }) => {
    const orderNumber = match.params.orderNumber;
    return {
      ...props,
      title: replaceRichText(props.primary.title, { number: orderNumber }),
      orderNumber,
    };
  }),
);

const enhanceOrdersList = compose(
  mapProps(props => {
    const isInactiveOrders = props.primary.orderListType === 'inactive';
    return {
      ...props,
      title: props.primary.title,
      isInactiveOrders,
      orders: props.userOrders.orders.filter(
        ({ isCancelled, isOpen }) =>
          isInactiveOrders ? isCancelled || !isOpen : !isCancelled && isOpen,
      ),
    };
  }),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      if (!props.isSingleOrder) {
        fetchUserOrders()
          .then(response => buildUserOrders(response))
          .then(orders => props.setUserOrders(orders))
          .catch(err => {
            props.setUserOrders({ response: err, orders: [] });
            if (err.status === 401) {
              const localisedLogin = localiseUrl(props.country, '/login');
              const currentPath = window.location.pathname;
              const currentSearch = window.location.search;
              const currentUrl = `${currentPath}${currentSearch}`;
              logger.info('Auth redirect: orders', currentPath);
              window.location = `${localisedLogin}?return_to=${currentUrl}`;
            }
          });
      }
    },
  }),
);

const enhance = compose(
  withCountry,
  withUserOrders,
  mapProps(props => ({
    ...props,
    isSingleOrder: props.primary.orderListType === 'single-order',
  })),
  when(props => props.isSingleOrder, enhanceSingleOrder, enhanceOrdersList),
);

export default enhance(UserOrders);



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserOrders/index.js